module.exports = __webpack_public_path__ + "img/logo-mastery.c4d1a5f.webp";